module.exports = __webpack_public_path__ + "img/1548946506.f6ef8d6a.jpg";